/* eslint-disable @typescript-eslint/no-explicit-any */
import { Node } from 'reactflow';
import { NodeService } from '../services/NodeService';

/**
 * Atualiza as edges do workflow quando um node é testado
 */
export const updateWorkflowEdges = (node: Node, output: any) => {
  if (!node || !output) return;
  
  try {
    // Preparar metadados específicos para diferentes tipos de node
    let edgeMetadata = {};
    
    // Tratamento especial para node do tipo "if"
    if (node.data?.type === 'if') {
      // Extrair resultado
      const result = output.result;
      
      // Simplificado: apenas incluir o campo "condition" com valor "true" ou "false"
      edgeMetadata = {
        condition: result === true ? 'true' : 'false'
      };
      
      console.log('[NodeUtils] Metadados simplificados do IF node:', edgeMetadata);
    }
    
    // Dispatch evento para atualizar as edges com o output do teste e metadados
    window.dispatchEvent(
      new CustomEvent('updateEdgeInput', {
        detail: { 
          nodeId: node.id, 
          output,
          metadata: edgeMetadata,
          nodeType: node.data?.type
        }
      })
    );
    
    // Dispatch evento genérico para resultado de teste do workflow
    window.dispatchEvent(
      new CustomEvent('workflowTestResult', {
        detail: { 
          nodeId: node.id, 
          result: output,
          metadata: edgeMetadata,
          nodeType: node.data?.type
        }
      })
    );
  } catch (error) {
    console.error('Erro ao atualizar edges:', error);
  }
};

/**
 * Executa um node com polling para tipos específicos (openai_assistant, openai_embedding)
 */
export const executeNodeWithPolling = async (
  node: Node,
  input: any = {},
  organizationId: string,
  workspaceId: string,
  formValues: any = {}
): Promise<any> => {
  // Criar uma cópia do node para não modificar o original
  const nodeToExecute = JSON.parse(JSON.stringify(node));
  
  // Mesclar as configurações do formulário com as configurações do node
  if (formValues && Object.keys(formValues).length > 0) {
    // Certificar-se de que data.config existe
    if (!nodeToExecute.data) nodeToExecute.data = {};
    if (!nodeToExecute.data.config) nodeToExecute.data.config = {};
    
    // Excluir o campo 'input' dos formValues para não interferir com o input do teste
    const { input: _, ...configValues } = formValues;
    
    // Mesclar as configurações, priorizando os valores do formulário
    nodeToExecute.data.config = {
      ...nodeToExecute.data.config,
      ...configValues
    };
  }
  
  // Executar node
  const result = await NodeService.executeNode(
    nodeToExecute,
    input,
    organizationId,
    workspaceId
  );
  
  // Polling para nodes assíncronos
  if (result.nodeId && (node.data?.type === 'openai_assistant' || node.data?.type === 'openai_embedding')) {
    return await NodeService.pollNodeStatus(result.nodeId as string);
  }
  
  // Retorna o resultado para outros tipos
  return result.Result ?? result.result ?? result.content ?? result;
};
